import React from 'react'
import { Message as SemanticMessage } from 'semantic-ui-react';

const Message = (props) => {

    return(
        !props.isArray ? <SemanticMessage {...props} onDismiss={props.onClose} /> : (
            <SemanticMessage info={props.info} warning={props.warning} error={props.error} success={props.success} onDismiss={props.onClose}> 
                {props.header && <SemanticMessage.Header>{props.header}</SemanticMessage.Header>}
                { props.content && <SemanticMessage.List>
                   { props.content.map(item => <SemanticMessage.Item key={item}>{item}</SemanticMessage.Item>)}
                </SemanticMessage.List>
                }
            </SemanticMessage>
        )
    )
}

export default Message